import React, { useState, useRef, useEffect } from "react";
import Spinner from "../spinner/Spinner"
import "./DropdownButton.css"; 

type DropdownOption = {
    label: string;
    onClick: () => void;
    id: string; // Add a unique identifier
};

type DropdownButtonProps = {
    label: string; // Text displayed on the button
    menuOptions: DropdownOption[]; // Options in the dropdown
    Icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>; // Optional icon
    disabled?: boolean;
    small?: boolean;
    isLoading?: boolean;
};

const DropdownButton = ({
    label,
    menuOptions,
    Icon,
    small = false,
    isLoading = false,
    disabled = false,
}: DropdownButtonProps) => {
    const [open, setOpen] = useState(false);
    const dropdownRef = useRef<HTMLDivElement | null>(null);

    const toggleDropdown = () => {
        if (!disabled) setOpen((prev) => !prev);
    };

    const handleOptionClick = (onClick: () => void) => {
        onClick();
        setOpen(false); // Close dropdown after selection
    };

     // Close dropdown if click outside
     useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div className={`dropdown ${small ? "small" : ""}`} ref={dropdownRef}>
            <button
                type="button"
                className="dropdown-button sharedButton"
                onClick={toggleDropdown}
                disabled={isLoading ? true : disabled}
            >
                {Icon && <Icon className="iconLeft" fill="#FFFFFF" width="16px" height="16px" />}
                {label}
                {isLoading ? <Spinner /> : <span className="arrow-down">▼</span>}
            </button>
            {open && (
                <ul className="dropdown-menu">
                    {menuOptions.map((option) => (
                        <li key={option.id}>
                            <button
                                type="button"
                                onClick={() => handleOptionClick(option.onClick)}
                            >
                                {option.label}
                            </button>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default DropdownButton;